"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanySwitchHeader = CompanySwitchHeader;
exports.CompanySwitchOption = CompanySwitchOption;
exports.CompanySwitchList = CompanySwitchList;
exports.default = CompanySwitch;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const cancelable_promise_1 = require("cancelable-promise");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const react_i18next_1 = require("react-i18next");
const react_native_paper_1 = require("react-native-paper");
const UserContext_1 = require("../contexts/UserContext");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const MyProfile_1 = __importDefault(require("../api/MyProfile"));
const Loading_1 = __importDefault(require("../components/Loading"));
const Button_1 = __importDefault(require("../components/Button"));
const ModalWrapper_1 = __importDefault(require("../components/ModalWrapper"));
const FirebaseAnalytics_1 = __importDefault(require("../shared/FirebaseAnalytics"));
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const FadeInView_1 = __importDefault(require("../components/FadeInView"));
const useStyles = () => {
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const THEME = (0, ThemeContext_1.useTheme)();
    return react_native_1.StyleSheet.create({
        flex: {
            alignItems: 'center',
            flexDirection: 'row',
            justifyContent: 'center'
        },
        fill: {
            alignItems: 'center',
            flex: 1
        },
        label: {
            borderRadius: 2,
            marginVertical: 4,
            marginHorizontal: 4,
            paddingHorizontal: 6,
            paddingVertical: 2
        },
        rightAction: {
            width: size != 'sm' ? 56 : 44,
            justifyContent: 'center',
            alignItems: 'flex-end',
            marginLeft: 12
        },
        primaryPill: {
            backgroundColor: '#777',
            borderRadius: 4,
            paddingHorizontal: 10,
            paddingVertical: 6,
            alignSelf: 'flex-end'
        },
        setPrimaryBtn: {
            borderRadius: 4,
            paddingHorizontal: 10,
            paddingVertical: 6,
            borderWidth: 1,
            borderColor: THEME.Primary,
            backgroundColor: 'transparent',
            alignSelf: 'flex-end'
        }
    });
};
function CompanySwitchHeader(props) {
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Apartment, size: 20, color: THEME.Secondary }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontWeight: '500', fontSize: (size != 'sm' ? 18 : 16), marginLeft: 8 }, children: props.text }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginBottom: -4, marginRight: -12 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { hitSlop: 12, type: "borderless", onPress: props.onClose, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Xmark, size: 20, color: THEME.Text, style: { margin: 4 } }) }) })] }));
}
;
function CompanySwitchOption(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const STYLES = (0, Theme_1.useGlobalStyles)();
    const styles = useStyles();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const isDark = (0, ThemeContext_1.useIsDark)();
    const allowPress = props.allowPress ?? true;
    const showIcon = props.showIcon ?? true;
    const showPrimaryAction = props.showPrimaryAction ?? true;
    let sizeName = props.fontSize ?? (size != 'sm' ? 18 : 14);
    let sizeLabel = props.fontSize ?? (size != 'sm' ? 16 : 12);
    let role = {
        admin: props.role?.includes('A') ?? false,
        ptoApprover: props.role?.includes('P') ?? false,
        employee: props.role?.includes('E') ?? false,
        contractor: props.role?.includes('C') ?? false,
        former: props.role?.includes('F') ?? false
    };
    return ((0, jsx_runtime_1.jsx)(react_native_1.Pressable, { disabled: !allowPress, onPress: props.onPress, style: ({ pressed }) => [
            STYLES.button,
            { paddingVertical: 0 },
            allowPress && pressed ? STYLES.pressed : null,
        ], children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', alignItems: 'center', padding: 12 }, children: [showIcon && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: { paddingLeft: 4, paddingRight: 16 }, children: props.selected ? ((0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Check, size: 20, color: THEME.Primary, style: { outlineWidth: 0 } })) : ((0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Apartment, size: 20, color: THEME.TextLight, style: { outlineWidth: 0 } })) })), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 1, flexDirection: 'column', paddingRight: 8 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { fontSize: sizeName, color: THEME.Text, textAlign: 'left' }, children: props.name }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', marginHorizontal: -4, flexWrap: 'wrap' }, children: [props.isPrimary && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: [styles.label, { backgroundColor: THEME.Tertiary }], children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { fontSize: sizeLabel - 2, color: isDark ? THEME.White : THEME.Text, fontWeight: '700' }, children: t('profile:text.primary') }) })), role.admin && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: [styles.label, { backgroundColor: THEME.Secondary }], children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { fontSize: sizeLabel - 2, color: THEME.White, fontWeight: '500' }, children: t('profile:text.roleA') }) })), role.ptoApprover && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: [styles.label, { backgroundColor: THEME.Secondary }], children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { fontSize: sizeLabel - 2, color: THEME.White, fontWeight: '500' }, children: t('profile:text.roleP') }) })), role.employee && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: [styles.label, { backgroundColor: `${THEME.Primary}DD` }], children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { fontSize: sizeLabel - 2, color: THEME.White, fontWeight: '500' }, children: t('profile:text.roleE') }) })), role.contractor && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: [styles.label, { backgroundColor: `${THEME.Primary}88` }], children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { fontSize: sizeLabel - 2, color: THEME.White, fontWeight: '500' }, children: t('profile:text.roleC') }) })), role.former && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: [styles.label, { backgroundColor: THEME.CoolGray }], children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { fontSize: sizeLabel - 2, color: THEME.White, fontWeight: '500' }, children: t('profile:text.roleF') }) }))] })] }), showPrimaryAction && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.rightAction, children: (() => {
                        const savingPrimary = props.savingPrimary ?? false;
                        const disableAll = props.disablePrimaryAction ?? false;
                        const isPrimary = props.isPrimary ?? false;
                        const canSet = !savingPrimary &&
                            !disableAll &&
                            !isPrimary;
                        const canClear = !savingPrimary &&
                            !disableAll &&
                            isPrimary &&
                            typeof props.onClearPrimary === 'function';
                        const canPress = canSet || canClear;
                        if (savingPrimary) {
                            return (0, jsx_runtime_1.jsx)(react_native_1.ActivityIndicator, { size: "small", color: THEME.Primary });
                        }
                        const icon = isPrimary ? Theme_1.ICONS.Solid.Star : Theme_1.ICONS.Regular.Star;
                        const baseColor = isPrimary ? THEME.Tertiary : THEME.Primary;
                        const displayOpacity = canPress ? 1 : 0.35;
                        return ((0, jsx_runtime_1.jsx)(react_native_1.Pressable, { disabled: !canPress, accessibilityRole: "button", accessibilityLabel: isPrimary
                                ? t('profile:text.primary')
                                : t('profile:text.setAsPrimary'), onPress: (e) => {
                                e?.stopPropagation?.();
                                if (canSet)
                                    props.onSetPrimary?.();
                                else if (canClear)
                                    props.onClearPrimary?.();
                            }, onPressIn: (e) => e?.stopPropagation?.(), hitSlop: 12, style: ({ pressed }) => [
                                { padding: 6, borderRadius: 6, opacity: displayOpacity },
                                canPress && pressed ? STYLES.pressedOpacity : null
                            ], children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: icon, size: 18, color: baseColor, style: { outlineWidth: 0 } }) }));
                    })() }))] }) }));
}
;
function CompanySwitchList(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const STYLES = (0, Theme_1.useGlobalStyles)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const promise = react_1.default.useRef(null);
    const [status, setStatus] = react_1.default.useState('loading');
    const [otherCompanies, setOtherCompanies] = react_1.default.useState([]);
    const refresh = react_1.default.useCallback(() => {
        promise.current?.cancel();
        setStatus('loading');
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then(async (token) => {
            const names = await MyProfile_1.default.getClientNames(token);
            return { names };
        })).then(({ names }) => {
            let other = [];
            let clients = userContext.clientList;
            for (let c of clients) {
                if (c.id != userContext.client?.id) {
                    other.push({
                        id: c.id,
                        name: names?.[c.id],
                        role: c.role
                    });
                }
            }
            setOtherCompanies(other);
            setStatus('done');
            props.onDataLoaded?.(other);
        }).catch(e => {
            setStatus('error');
        });
    }, []);
    react_1.default.useEffect(() => {
        refresh();
        return () => promise.current?.cancel();
    }, []);
    const selectClient = (id) => {
        FirebaseAnalytics_1.default.LogEvent('feature_used', {
            'feature': 'Switch Company',
            'client': userContext.client?.id,
            'employee': userContext.employee?.employeeId
        });
        userContext.selectClient(id);
        props.onSelected();
    };
    var otherCompaniesFiltered = otherCompanies;
    if (props.filter?.trim()) {
        otherCompaniesFiltered = otherCompanies?.filter((c) => c.name?.toUpperCase()?.includes(props.filter?.trim()?.toUpperCase()));
    }
    return ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginVertical: 6 }, children: (status == 'done')
            &&
                (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [otherCompaniesFiltered?.map((item, index, array) => (0, jsx_runtime_1.jsxs)(FadeInView_1.default, { children: [(0, jsx_runtime_1.jsx)(CompanySwitchOption, { name: item.name, role: item.role, savingPrimary: props.savingPrimaryId === item.id, disablePrimaryAction: !!props.savingPrimaryId, isPrimary: item.id === props.primaryClientId, onSetPrimary: () => props.setPrimary(item.id), onClearPrimary: () => props.setPrimary(null), onPress: () => selectClient(item.id) }), (index < array.length - 1) &&
                                    (0, jsx_runtime_1.jsx)(react_native_1.View, { style: STYLES.separator })] })), (otherCompaniesFiltered?.length == 0) &&
                            (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { margin: 12, flexDirection: 'row', justifyContent: 'center' }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: 16, opacity: 0.8 }, children: t('common:text.noResults') }) })] })
            ||
                (0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: true, loading: status == 'loading', error: status == 'error', onRetry: () => refresh() }) }));
}
;
function CompanySwitch(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const primaryClientId = userContext.primaryClientId;
    const [savingPrimaryId, setSavingPrimaryId] = react_1.default.useState(null);
    const savingPrimaryRef = react_1.default.useRef(null);
    const [filterVisible, setFilterVisible] = react_1.default.useState(false);
    const [filterText, setFilterText] = react_1.default.useState('');
    const [filterFocus, setFilterFocus] = react_1.default.useState(false);
    const setPrimary = async (clientId) => {
        if (savingPrimaryRef.current)
            return;
        savingPrimaryRef.current = clientId ?? '__clear__';
        const prev = userContext.primaryClientId;
        const spinnerId = clientId ?? prev ?? '__clear__';
        setSavingPrimaryId(spinnerId);
        userContext.updatePrimaryClientId(clientId);
        try {
            const auth = await userContext.getToken();
            if (clientId) {
                await MyProfile_1.default.setPrimaryClient(auth, { clientId });
            }
            else {
                await MyProfile_1.default.clearPrimaryClient(auth);
            }
        }
        catch (e) {
            userContext.updatePrimaryClientId(prev ?? null);
        }
        finally {
            savingPrimaryRef.current = null;
            setSavingPrimaryId(null);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(ModalWrapper_1.default, { navigation: props.navigation, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { paddingHorizontal: 12, paddingTop: 12 }, children: [(size != 'sm' || (!filterFocus && filterText == '')) &&
                        (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginVertical: 6 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: (size != 'sm' ? 19 : 17), fontWeight: '500' }, children: t('profile:text.selectedCo') }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                                        marginVertical: 6,
                                        backgroundColor: THEME.UltraLightGray,
                                        borderRadius: 6,
                                        overflow: 'hidden',
                                    }, children: (0, jsx_runtime_1.jsx)(CompanySwitchOption, { selectedRow: true, selected: true, allowPress: false, name: userContext.client?.name, role: userContext.user?.claims?.clients?.[userContext.client?.id], isPrimary: userContext.client?.id === primaryClientId, savingPrimary: savingPrimaryId === userContext.client?.id, disablePrimaryAction: !!savingPrimaryId, onSetPrimary: () => setPrimary(userContext.client?.id), onClearPrimary: () => setPrimary(null) }) })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginVertical: 6, marginTop: 16 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: (size != 'sm' ? 19 : 17), fontWeight: '500' }, children: t('profile:text.chooseDiffCo') }) }), filterVisible &&
                        (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { marginVertical: 6, flexDirection: 'row', alignItems: 'center' }, children: [(0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { accessibilityLabel: t('common:text.search'), placeholder: t('common:text.search'), value: filterText ?? '', style: { flex: 1, paddingRight: 20 }, autoFocus: false, selectTextOnFocus: true, dense: true, mode: "outlined", onChangeText: (v) => setFilterText(v), onFocus: () => setFilterFocus(true), onBlur: () => setFilterFocus(false) }), (filterFocus || filterText != '') &&
                                    (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { onPress: () => {
                                            setFilterText('');
                                            setFilterFocus(false);
                                            react_native_1.Keyboard.dismiss();
                                        }, style: {
                                            paddingVertical: 8, width: 40, marginLeft: -40, flexDirection: 'row', justifyContent: 'center'
                                        }, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Xmark, size: 24, color: THEME.Text, style: { outlineWidth: 0 } }) })] })] }), (0, jsx_runtime_1.jsx)(react_native_1.ScrollView, { keyboardShouldPersistTaps: "handled", contentContainerStyle: { paddingHorizontal: 12, paddingBottom: 12 }, children: (0, jsx_runtime_1.jsx)(CompanySwitchList, { filter: filterText, primaryClientId: primaryClientId, savingPrimaryId: savingPrimaryId, setPrimary: setPrimary, onDataLoaded: (data) => setFilterVisible(data?.length > 4), onSelected: () => props.navigation.goBack() }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { paddingHorizontal: 12, paddingTop: 12, paddingBottom: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { type: "solid", text: t('common:buttons.cancel'), onPress: () => props.navigation.goBack() }) })] }));
}
;
